import type { PropsWithChildren } from 'react';

import { Border, Col } from './styles';

interface ZipcodeCheckerItemProps
  extends PropsWithChildren<{
    borderLeft?: boolean;
    borderRight?: boolean;
    heading?: boolean;
    colSize?: string;
    align?: string;
  }> {}

export const ZipcodeCheckerItem = ({ children, borderLeft, borderRight, colSize }: ZipcodeCheckerItemProps) => {
  return (
    <Col xs={colSize}>
      {borderLeft && <Border borderLeft={borderLeft} />}

      {children}

      {borderRight && <Border borderRight={borderRight} />}
    </Col>
  );
};
